import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';

const Fitness = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          My Fitness Journey
        </Typography>
        <Typography variant="body1" paragraph></Typography>
        <Typography variant="body1" paragraph>
          I started my fitness journey after gaining weight as a
          vegetarian—ironically, while many lose weight on this lifestyle, I
          experienced the opposite. Unhappy with my body, I joined a traditional
          gym, but lack of discipline kept me from showing up. My friend Chris,
          an avid lifter, suggested CrossFit, believing I needed structure—and
          he was right. At first, I hated it, but over time, I grew stronger, my
          perspective on fitness shifted, and my physique improved. I didn’t
          lose weight, but I felt incredible—stronger and in the best shape of
          my life. Now, I train in my garage with a drive I never had before
          CrossFit. I love seeing progress in myself and others.
        </Typography>
      </Box>
    </Container>
  );
};

export default Fitness;
